import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveQuestionMetaType,
  PreAssessmentData
} from "../../types/preAssessment";
import {
  AssessmentData,
  QuestionProgressStatus,
  SectionProgressStatus,
  SectionTimeSpent
} from "../../types/assessmentOngoing";

interface INIT {
  uploadConfig: any;
}

const INIT_STATE: INIT = {
  uploadConfig: {}
};

const SubjectiveSlice = createSlice({
  name: "SubjectiveSlice",
  initialState: INIT_STATE,
  reducers: {
    mutateUploadConfig: (state, action) => {
      console.log("action.payload", action.payload);
      state.uploadConfig = action.payload;
    },
    resetState: () => {
      return INIT_STATE;
    }
  }
});

export default SubjectiveSlice;

export const SubjectiveActions = SubjectiveSlice.actions;
